import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import ProductCard from "./ProductCard";
import LoadingSpinner from "./components/LoadingSpinner";
import "./App.css";
import { getOrFetch } from "./utils/apiCache";

function CategoryPreview({ categoryId, title, link }) {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchProducts = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const data = await getOrFetch(
        `categoryPreview:${categoryId}:per_page:4`,
        () =>
          axios
            .get("https://floriakw.com/wp-json/wc/v3/products", {
              auth: {
                username: "ck_39cd5450af63b97a35e502d9a0a75925866fefab",
                password: "cs_15701bd9b4392a3b6e5a3d5fa4d326d7acb0a0bf",
              },
              params: {
                category: categoryId,
                per_page: 4,
                status: "publish",
              },
            })
            .then((r) => r.data),
        { ttlMs: 10 * 60 * 1000 }
      );
      setProducts(data);
    } catch (err) {
      console.error("Category preview error:", err);
      setError("حدث خطأ أثناء تحميل المنتجات. يرجى المحاولة مرة أخرى.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, [categoryId]);

  // Loading state
  if (isLoading) {
    return (
      <section className="featured-section">
        <div className="container">
          <div className="featured-header">
            <h2>{title}</h2>
          </div>
          <LoadingSpinner size="medium" color="black" withText={true} />
        </div>
      </section>
    );
  }

  // Error state
  if (error) {
    return (
      <section className="featured-section">
        <div className="container">
          <div className="featured-header">
            <h2>{title}</h2>
          </div>
          <div className="error-message">
            <p>{error}</p>
            <button className="retry-button" onClick={fetchProducts}>
              إعادة المحاولة
            </button>
          </div>
        </div>
      </section>
    );
  }

  // No products state
  if (products.length === 0) {
    return (
      <section className="featured-section">
        <div className="container">
          <div className="featured-header">
            <h2>{title}</h2>
            <Link to={link} className="view-all">
              عرض الجميع
            </Link>
          </div>
          <div className="no-products">
            <p>لا توجد منتجات متاحة حاليًا في هذا القسم</p>
          </div>
        </div>
      </section>
    );
  }

  // Success state
  return (
    <section className="featured-section">
      <div className="container">
        {/* Header row */}
        <div className="featured-header">
          <h2>{title}</h2>
          <Link to={link} className="view-all">
            عرض الجميع
          </Link>
        </div>

        {/* Products grid */}
        <div className="grid">
          {products.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default CategoryPreview;
